<div class="overlay" (click)="onOverlayClicked($event)">
  <div class="dynamic-modal" (click)="onModalClicked($event)">
    <ng-template appInsertion> </ng-template>
  </div>
</div>
